export const ACCEPTED_IMAGE_TYPES = ".jpeg,.jpg,.png";
export const ACCEPTED_FILE_TYPES = ".csv";

export const ERROR_COUNT_OF_IMAGES = "Please select only 1 photo.";
export const ERROR_COUNT_OF_FILES = "Please select only 1 file.";
export const ERROR_IMAGE_IS_CORRUPTED =
  "File is corrupted. Please upload another file.";
export const ERROR_INCORRECT_FORMAT = "Incorrect format. Available formats";
